import {
  sliders,
  performanceLabels,
  fundamentals,
  multiplesRatios
} from 'buyside/util/ideaFilterConstants';
import { compactInteger } from 'humanize-plus';
import { titleize } from 'inflection';

//This helper takes care of all the random ranges we have and their labels
//Probably will need to refactor this at some point if it gets too clunky, we have muchos ranges

const calculateRangeValue = (value, max, min) => {
  const splitValue = value.split('_');
  let rangeValue;
  if (!splitValue[1]) {
    rangeValue = value.replace('_', '-') + max;
  } else if (!splitValue[0]) {
    rangeValue = min + value.replace('_', '-');
  } else {
    rangeValue = value.replace('_', '-');
  }
  return rangeValue;
};

const getMetricValue = (value, category) => {
  if (category === 'user_ratings_count')
    return { label: 'Number of Ratings', value: value === '10_' ? '10+' : value.replace('_', '-') };
  if (category === 'comments_count')
    return { label: 'Number of Views', value: value === '10_' ? '10+' : value.replace('_', '-') };
  if (
    category === 'standard_credit_rating' ||
    category === 'moody_credit_rating' ||
    category === 'fitch_credit_rating'
  ) {
    return {
      value: calculateRangeValue(value, 'AAA', 'NR'),
      label: titleize(category.replace('_credit', '')).replace('Standard', 'S&P')
    };
  }
  if (category === 'sellside_consensus')
    return { label: 'Sellside Consensus', value: calculateRangeValue(value, 'Sell', 'Buy') };
  if (category === 'community_rating')
    return { label: 'Community Rating', value: calculateRangeValue(value, '5', '0') };
  if (performanceLabels.findIndex(p => p.name === category) > -1) {
    return { value: calculateRangeValue(value, '50+', '-50'), label: titleize(category) };
  }

  let metric;
  const list = fundamentals.concat(multiplesRatios);
  list.forEach(data => {
    if (data.name === category) metric = data;
  });
  if (category === 'amount_outstanding') metric = { label: 'Amount Outstanding' };
  if (metric) {
    const slider = sliders[category];
    const range = value.split('_').map(v => (v === '' ? null : Number(v)));
    let firstNumber = range[0] === null ? slider.ticks[0] : range[0];
    let secondNumber = range[1] === null ? slider.ticks[slider.ticks.length - 1] : range[1];
    if (firstNumber > 1000 || firstNumber < -1000) firstNumber = compactInteger(firstNumber);
    if (secondNumber > 1000 || secondNumber < -1000) secondNumber = compactInteger(secondNumber);
    return { label: metric.label, value: `${firstNumber}-${secondNumber}` };
  } else {
    return { label: titleize(category), value: titleize(value) };
  }
};

export default getMetricValue;
